import { useState } from 'react';
import { connectHubspot, connectGhl, connectPipedrive, connectSalesforce } from '../../services';
import { useAppContext } from '../../context/AppContext';
import { ConnectWiseModal } from '../Modals';
import salesforceImg from '../../assets/images/force.png';
import pipeImg from '../../assets/images/pipe.png';
import hub from '../../assets/images/hub.png';
import ghl from '../../assets/images/ghl.png';
import wiseImg from '../../assets/images/cw.png';

const CRM_OPTIONS = [
  { id: 'hubspot', label: 'HubSpot', img: hub, connect: connectHubspot },
  { id: 'ghl', label: 'GoHighLevel', img: ghl, connect: connectGhl },
  { id: 'pipedrive', label: 'Pipedrive', img: pipeImg, connect: connectPipedrive },
  { id: 'salesforce', label: 'Salesforce', img: salesforceImg, connect: connectSalesforce },
  { id: 'wise', label: 'ConnectWise', img: wiseImg, authType: 'api_key' },
];

export const CRMConnect = ({ onSuccess }) => {
  const { base_url, token } = useAppContext();
  const [wiseModalOpen, setWiseModalOpen] = useState(false);

  const handleConnect = async (crm) => {
    if (crm.authType === 'api_key') {
      setWiseModalOpen(true);
      return;
    }

    const redirectUrl = await crm.connect(base_url, token, 'initial');
    window.location.href = redirectUrl;
  };

  const handleWiseSuccess = () => {
    setWiseModalOpen(false);
    onSuccess?.();
  };

  return (
    <div>
      <div className="step-header">
        <h2>Connect Your CRM</h2>
        <p>
          Connecting to your CRM allows Slipstream to retrieve sales data to create invoices.
          Information about the full scope of access requested will be displayed when you select your CRM below.
        </p>
      </div>

      <div className="connect-cards">
        {CRM_OPTIONS.map((crm) => (
          <div key={crm.id} className="connect-card">
            <div className="connect-card-info">
              <div className="connect-card-icon hubspot">
                <img src={crm.img} alt="" width={44} height={44} />
              </div>
              <div className="connect-card-text">
                <strong>{crm.label}</strong>
                <span>CRM — deal, contact &amp; invoice data</span>
              </div>
            </div>
            <button
              type="button"
              className="connect-btn"
              onClick={() => handleConnect(crm)}
            >
              Connect
            </button>
          </div>
        ))}
      </div>

      <ConnectWiseModal
        isOpen={wiseModalOpen}
        onClose={() => setWiseModalOpen(false)}
        onSuccess={handleWiseSuccess}
      />
    </div>
  );
};
